var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMake = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_6643)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_201_6643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2703 11.0099H10.2051C10.0473 11.0099 9.91992 10.8825 9.91992 10.7247V3.10067C9.92079 2.94381 10.0482 2.81727 10.2051 2.81641H12.2703C12.4272 2.81641 12.5555 2.94294 12.5563 3.10067V10.7247C12.5563 10.8816 12.4298 11.0099 12.2721 11.0099C12.2721 11.0099 12.2721 11.0099 12.2712 11.0099H12.2703Z",
    fill: "url(#paint0_linear_201_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69755 11.0395L0.852413 10.1104C0.712013 10.0394 0.654813 9.86862 0.725879 9.72735L4.14835 2.91882C4.21941 2.77842 4.39015 2.72122 4.53141 2.79229L6.37655 3.71962C6.51695 3.79069 6.57415 3.96142 6.50308 4.10269L3.07975 10.913C3.00868 11.0534 2.83795 11.1106 2.69668 11.0395H2.69755Z",
    fill: "url(#paint1_linear_201_6643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14756 10.888L9.6105 3.46412C9.64083 3.30985 9.54116 3.16079 9.38776 3.12959L7.36323 2.72052C7.2081 2.68932 7.05816 2.78985 7.02696 2.94499L5.56403 10.3697C5.5337 10.524 5.63336 10.6731 5.78763 10.7043L7.8113 11.1125C7.96556 11.1437 8.11549 11.0449 8.14756 10.8906V10.888Z",
    fill: "url(#paint2_linear_201_6643)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_6643",
    x1: 7.41439,
    y1: 8.32321,
    x2: 12.9871,
    y2: 6.26834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6D00CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_6643",
    x1: 2.52421,
    y1: 7.38735,
    x2: 8.51461,
    y2: 4.79689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E80DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C024ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B02DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_6643",
    x1: 1.12669,
    y1: 9.29505,
    x2: 13.4065,
    y2: 4.77365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E80DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C024ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A42BE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8527D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6021C3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_6643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_201_6643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMake);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Make.af08bdaa477d1879c4ab6a83344d1aff.svg";